import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-84c83104")
const _hoisted_1 = { id: "modal-manager-component" }
_popScopeId()

import { ref, provide, computed, watch } from "vue";
import { store } from "@/store";
import useHandleModal from "@/composables/useHandleModal";
import { ActionTypes } from "@/store/actions";
import {
  LabelSizes,
  LabelShapes,
  LabelMaterials,
  CustomLabelSizes,
  GuideLines,
  Help,
  PrintPreview,
  PrintingCompleted,
  PrintingHelp,
  TroubleShooting,
  SmallPage,
  ShiftedVertical,
  Mismatched,
  AlignmentWizard,
  Contact,
  SaveLabel,
  LoginModal,
  ForgotPassword,
  NameAndContinue,
  ConfirmBack,
  SaveConfirmation,
} from "@/components/Modals/imports";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// Vue 3.2 script setup api
const {
  showModal,
  bounceTransition,
  fadeTransition,
  timeOut,
  handleModal,
  handleTransition,
} = useHandleModal();

const closeModal = async () => {
  await handleModal();
  store.dispatch(ActionTypes.SET_MODAL, "");
};

provide("showModal", showModal);
provide("bounceTransition", bounceTransition);
provide("fadeTransition", fadeTransition);
provide("timeOut", timeOut);
provide("handleModal", handleModal);
provide("closeModal", closeModal);
provide("handleTransition", handleTransition);

const currentModal = ref("");
const modalMessage = computed<string>(() => store.getters.modal);

watch(modalMessage, async (newMessage, oldMessage) => {
  if (newMessage.length && oldMessage.length) {
    await handleTransition();
  } else {
    if (newMessage.length) {
      await handleModal();
    }
  }

  currentModal.value = newMessage;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentModal.value === 'labelSizes')
      ? (_openBlock(), _createBlock(_unref(LabelSizes), { key: 0 }))
      : (currentModal.value === 'labelShapes')
        ? (_openBlock(), _createBlock(_unref(LabelShapes), { key: 1 }))
        : (currentModal.value === 'labelMaterials')
          ? (_openBlock(), _createBlock(_unref(LabelMaterials), { key: 2 }))
          : (currentModal.value === 'customLabelSizesWidth')
            ? (_openBlock(), _createBlock(_unref(CustomLabelSizes), {
                key: 3,
                idx: 0
              }))
            : (currentModal.value === 'customLabelSizesHeight')
              ? (_openBlock(), _createBlock(_unref(CustomLabelSizes), {
                  key: 4,
                  idx: 1
                }))
              : (currentModal.value === 'guideLines')
                ? (_openBlock(), _createBlock(_unref(GuideLines), { key: 5 }))
                : (currentModal.value === 'help')
                  ? (_openBlock(), _createBlock(_unref(Help), { key: 6 }))
                  : (currentModal.value === 'printPreview')
                    ? (_openBlock(), _createBlock(_unref(PrintPreview), { key: 7 }))
                    : (currentModal.value === 'printingCompleted')
                      ? (_openBlock(), _createBlock(_unref(PrintingCompleted), { key: 8 }))
                      : (currentModal.value === 'printingHelp')
                        ? (_openBlock(), _createBlock(_unref(PrintingHelp), { key: 9 }))
                        : (currentModal.value === 'troubleShooting')
                          ? (_openBlock(), _createBlock(_unref(TroubleShooting), { key: 10 }))
                          : (currentModal.value === 'smallPage')
                            ? (_openBlock(), _createBlock(_unref(SmallPage), { key: 11 }))
                            : (currentModal.value === 'shiftedVertical')
                              ? (_openBlock(), _createBlock(_unref(ShiftedVertical), { key: 12 }))
                              : (currentModal.value === 'mismatched')
                                ? (_openBlock(), _createBlock(_unref(Mismatched), { key: 13 }))
                                : (currentModal.value === 'alignmentWizard')
                                  ? (_openBlock(), _createBlock(_unref(AlignmentWizard), { key: 14 }))
                                  : (currentModal.value === 'contact')
                                    ? (_openBlock(), _createBlock(_unref(Contact), { key: 15 }))
                                    : (currentModal.value === 'saveLabel')
                                      ? (_openBlock(), _createBlock(_unref(SaveLabel), { key: 16 }))
                                      : (currentModal.value === 'loginModal')
                                        ? (_openBlock(), _createBlock(_unref(LoginModal), { key: 17 }))
                                        : (currentModal.value === 'forgotPassword')
                                          ? (_openBlock(), _createBlock(_unref(ForgotPassword), { key: 18 }))
                                          : (currentModal.value === 'nameAndContinue')
                                            ? (_openBlock(), _createBlock(_unref(NameAndContinue), { key: 19 }))
                                            : (currentModal.value === 'confirmBack')
                                              ? (_openBlock(), _createBlock(_unref(ConfirmBack), { key: 20 }))
                                              : (currentModal.value === 'saveConfirmation')
                                                ? (_openBlock(), _createBlock(_unref(SaveConfirmation), { key: 21 }))
                                                : _createCommentVNode("", true)
  ]))
}
}

})